import React from 'react';
import { Download, Upload, Eye } from 'lucide-react';
import { Config } from '../types';
import { exportJson, importJson } from '../utils/jsonUtils';

interface ActionsProps {
    config: Config;
    showPreview: boolean;
    onShowPreviewToggle: () => void;
    onConfigUpdate: (config: Config) => void;
}

const Actions: React.FC<ActionsProps> = ({ 
    config, 
    showPreview, 
    onShowPreviewToggle, 
    onConfigUpdate 
}) => {
    const handleImportJson = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            importJson(file)
                .then((importedConfig) => {
                    onConfigUpdate(importedConfig);
                    alert('فایل JSON با موفقیت بارگذاری شد');
                })
                .catch((error) => {
                    alert(error.message);
                });
        }
        event.target.value = '';
    };

    return (
        <div className="bg-white rounded-xl shadow-sm border p-6">
            <div className="flex flex-wrap gap-3 justify-center">
                <button
                    onClick={() => exportJson(config)}
                    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors text-sm font-medium"
                >
                    <Download size={18}/>
                    دانلود JSON
                </button>

                <label
                    className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 cursor-pointer transition-colors text-sm font-medium">
                    <Upload size={18}/>
                    بارگذاری JSON
                    <input
                        type="file"
                        accept=".json"
                        onChange={handleImportJson}
                        className="hidden"
                    />
                </label>

                <button
                    onClick={onShowPreviewToggle}
                    className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors text-sm font-medium"
                >
                    <Eye size={18}/>
                    {showPreview ? 'مخفی' : 'پیش‌نمایش'}
                </button>
            </div>

            {/* JSON Preview */}
            {showPreview && (
                <div className="mt-6 border-t pt-6">
                    <h3 className="text-sm font-medium text-gray-800 mb-3">پیش‌نمایش JSON:</h3>
                    <pre dir={'ltr'}
                         className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-xs leading-relaxed max-h-80 overflow-y-auto">
                        {JSON.stringify({
                            ...config,
                            list: config.list.map((item, index) => ({
                                ...item,
                                id: index + 1
                            }))
                        }, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default Actions; 